module.exports = __webpack_public_path__ + "img/logo-mobile.18633d66.svg";